// extracted by mini-css-extract-plugin
module.exports =  {"labelFont":"labelFont_GTCMU5d9","settingsWrapper":"settingsWrapper_AbM2w8EE"};